<template>
  <div>
    <!--container-->
    <section v-show="!isFinished" class="container">
      <!--questionBox-->
      <v-card class="questionBox mx-auto">
        <!-- transition -->
        <transition
          :duration="{ enter: 500, leave: 300 }"
          enter-active-class="animated zoomIn"
          leave-active-class="animated zoomOut"
          mode="out-in"
        >
          <!--qusetionContainer-->
          <div
            v-if="questionIndex < resultHistories.length"
            :key="questionIndex"
            class="questionContainer"
          >
            <header>
              <h4 class="text-center mb-3">{{ time }}</h4>
              <v-row class="mx-auto">
                <div
                  v-for="i in resultHistories.length"
                  :key="i"
                  :class="
                    `card-page ${
                      resultHistories[i - 1].selectedAnswerId != null
                        ? 'card-fulled'
                        : ''
                    } ${page === i ? 'card-active' : ''}`
                  "
                  @click="page = i"
                >{{ i }}</div>
              </v-row>
            </header>

            <!-- questionTitle -->
            <h2 class="titleContainer">
              {{ questionIndex + 1 }}.
              <latex :text="resultHistories[questionIndex].quiz.question"></latex>
            </h2>

            <!-- quizOptions -->
            <v-list-item-group class="optionContainer">
              <v-list-item
                v-for="(response, index) in resultHistories[
                  questionIndex
                ].quiz.answers"
                :key="index"
                class="option"
                :class="{
                  'is-selected':
                    resultHistories[questionIndex]
                      .selectedAnswerId === response.id,
                }"
                @click="selectOption(response)"
              >
                {{ index | charIndex }}.
                <latex :text="response.content"></latex>
              </v-list-item>
            </v-list-item-group>

            <!--quizFooter: navigation and progress-->
            <footer class="questionFooter">
              <!--pagination-->
              <nav class="pagination" role="navigation" aria-label="pagination">
                <!-- back button -->
                <button class="button" :disabled="questionIndex < 1" @click="prev()">Back</button>
                <v-btn class="button indigo" @click="finish()">Tugatish</v-btn>
                <button
                  class="button"
                  :class="
                    userResponses[questionIndex] == null
                      ? ''
                      : 'is-active'
                  "
                  :disabled="page + 1 >= resultHistories.length"
                  @click="next()"
                >
                  {{
                  resultHistories[questionIndex].selectedAnswerId ==
                  null
                  ? "Skip"
                  : "Next"
                  }}
                </button>
              </nav>
            </footer>
          </div>
        </transition>
      </v-card>
    </section>
  </div>
</template>

<script>
import resultHistoryService from "../../service/ResultHistory.service";
import resultService from "../../service/Result.service";
import examService from "../../service/Exam.service";
import subjectService from "../../service/Subject.service";
import Latex from "@/components/Latex";
export default {
  name: "ExamPage",
  components: {Latex},
  filters: {
    charIndex: function(i) {
      return String.fromCharCode(97 + i);
    },
  },
  data: function() {
    return {
      questionIndex: 0,
      page: 1,
      userResponses: [],
      isActive: false,
      resultHistories: [],
      jwt: "",
      result: {
        subjectId: "",
        startedTime: "",
        finishedTime: "",
        finished: "",
        score: "",
        userId: "",
        userName: "",
      },
      time: "",
      currentSubject: {
        id: "",
        name: "",
        examTime: "",
      },
      currentExam: {
        id: "",
        subjectId: "",
        startTime: "",
        finishTime: "",
      },
      isFinished: false,
    };
  },
  computed: {},
  watch: {
    page(newVal) {
      this.questionIndex = newVal - 1;
    },
  },
  created() {
    this.initial();
  },
  methods: {
    finish() {
      confirm("Siz rostan ham tugatmoqchimisiz?") &&
        this.finishResult();
    },
    getTime: function() {
      if (!this.isFinished) {
        setTimeout(() => {
          const seconds =
            this.currentSubject.examTime * 60 -
            Math.trunc(
              (new Date() - new Date(this.result.startedTime)) / 1000,
            );
          if (seconds < 0) {
            this.finishResult();
          }
          const minutes = Math.trunc(seconds / 60);
          this.time = `${
            Math.trunc(minutes / 60) > 0
              ? Math.trunc(minutes / 60) + " : "
              : ""
          }${minutes % 60} : ${seconds % 60}`;
          this.getTime();
        }, 1000);
      }
    },
    finishResult() {
      resultService.finish(this.result.id, this.jwt).then(res => {
        this.result = res.data;
        this.$router.push(`/result-history/${this.result.id}`);
      });
      this.isFinished = true;
    },
    createResult() {
      this.result.examId = this.$route.params.id;
    },
    initial() {
      this.jwt = this.$store.getters.jwt;
      this.createResult();
      examService.getOne(this.result.examId, this.jwt).then(res => {
        this.currentExam = res.data;
        subjectService
          .getOne(this.currentExam.subjectId, this.jwt)
          .then(res => {
            this.currentSubject = res.data;
          });
        resultService.getOrCreate(this.result, this.jwt).then(res => {
          this.result = res.data;

          if (this.result.finished) {
            this.$router.push("/pages/user");
          }
          resultHistoryService
            .migrate(this.result.id, this.jwt)
            .then(res => {
              this.resultHistories = res.data;

              this.createSkeleton();
              this.getTime();
            });
        });
      });
    },
    createSkeleton() {
      this.resultHistories.forEach(resultHistory => {
        this.userResponses.push(resultHistory.selectedAnswerId);
      });
    },
    restart: function() {
      this.questionIndex = 0;
      this.userResponses = Array(this.resultHistories.length).fill(
        null,
      );
    },
    sendOneResultHistory(index) {
      const history = Object.assign({}, this.resultHistories[index]);
      resultHistoryService
        .edit(history, history.id, this.jwt)
        .then(res => {
          this.resultHistories[index].selectedAnswerId =
            res.data.selectedAnswerId;
        });
    },
    selectOption: function(response) {
      this.resultHistories[this.questionIndex].selectedAnswerId =
        response.id;
      this.sendOneResultHistory(this.questionIndex);
    },
    next: function() {
      if (this.page <= this.resultHistories.length) {
        this.page++;
      }
    },

    prev: function() {
      if (this.resultHistories.length > 0) this.page--;
    },
    // Return "true" count in userResponses
    score: function() {
      // return this.userResponses.filter(function(val) { return val }).length;
    },
  },
};
</script>

<style lang="scss" scoped>
$trans_duration: 0.3s;
$primary_color: #3d5afe;

@import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700");

body {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  height: 100vh;

  /* mocking native UI */
  cursor: default !important; /* remove text selection cursor */
  user-select: none; /* remove text selection */
  user-drag: none; /* disbale element dragging */

  display: flex;
  align-items: center;
  justify-content: center;
}
.card-page {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5); /* Параметры тени */
  border: 1px solid #000;
  width: 35px;
  heigth: 30px;
  background-color: #ccc;
  text-align: center;
  border-radius: 4px;
  margin: 3px;
  color: #000;
  cursor: pointer;
}
.card-page:hover {
  background-color: $primary_color;
  color: white;
}
.card-fulled {
  background-color: cornflowerblue;
  color: white;
}
.card-active {
  border: 1px solid #ddd;
  width: 37px;
  background-color: $primary_color;
  color: white;
}
.button {
  transition: $trans_duration;
}
.title,
.subtitle {
  font-family: Montserrat, sans-serif;
  font-weight: normal;
}
.animated {
  transition-duration: $trans_duration/2;
}

.container {
  margin: 0 0.5rem;
}

.questionBox {
  width: 48rem;
  min-height: 30rem;

  position: relative;
  display: flex;

  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);

  header {
    background: rgba(0, 0, 0, 0.025);
    padding: 1.5rem;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    h1 {
      font-weight: bold;
      margin-bottom: 1rem !important;
    }
    .progressContainer {
      width: 60%;
      margin: 0 auto;
      > progress {
        margin: 0;
        border-radius: 5rem;
        overflow: hidden;
        border: none;

        color: $primary_color;
        &::-moz-progress-bar {
          background: $primary_color;
        }
        &::-webkit-progress-value {
          background: $primary_color;
        }
      }
      > p {
        margin: 0;
        margin-top: 0.5rem;
      }
    }
  }
  .titleContainer {
    text-align: center;
    margin: 0 auto;
    padding: 1.5rem;
  }

  .quizForm {
    display: block;
    white-space: normal;

    height: 100%;
    width: 100%;

    .quizFormContainer {
      height: 100%;
      margin: 15px 18px;

      .field-label {
        text-align: left;
        margin-bottom: 0.5rem;
      }
    }
  }
  .quizCompleted {
    width: 100%;
    padding: 1rem;
    text-align: center;

    > .icon {
      color: #ff5252;
      font-size: 5rem;

      .is-active {
        color: #00e676;
        background: #00e676;
      }
    }
  }
  .questionContainer {
    white-space: normal;

    height: 100%;
    width: 100%;

    .optionContainer {
      margin-top: 12px;
      flex-grow: 1;
      .option {
        border-radius: 290486px;
        padding: 0 18px !important;
        margin: 0 18px;
        margin-bottom: 12px;
        transition: $trans_duration;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.85);
        border: transparent 1px solid;

        &.is-selected {
          border-color: rgba(black, 0.25);
          background-color: darkgray;
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
        &:active {
          transform: scaleX(0.9);
        }
      }
    }

    .questionFooter {
      background: rgba(0, 0, 0, 0.025);
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      width: 100%;
      align-self: flex-end;

      .pagination {
        //padding: 10px 15px;
        margin: 15px 25px;
      }
    }
  }
}
.pagination {
  display: flex;
  justify-content: space-between;
}
.button {
  padding: 0.5rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 5rem;
  margin: 0 0.25rem;

  transition: 0.3s;

  &:hover {
    cursor: pointer;
    background: #eceff1;
    border-color: rgba(0, 0, 0, 0.25);
  }
  &.is-active {
    background: $primary_color;
    color: white;
    border-color: transparent;

    &:hover {
      background: darken($primary_color, 10%);
    }
  }
}

@media screen and (min-width: 769px) {
  .questionBox {
    align-items: center;
    justify-content: center;

    .questionContainer {
      display: flex;
      flex-direction: column;
    }
  }
}

@media screen and (max-width: 768px) {
  .sidebar {
    height: auto !important;
    border-radius: 6px 6px 0px 0px;
  }
  .questionBox {
    width: 25rem;
  }
}
</style>
